(function () {
  'use strict';

  if (window.__lpStickyInit) {
    return;
  }

  window.__lpStickyInit = true;

  function elementInViewport(element) {
    if (!element) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function bindStickyBars() {
    document.querySelectorAll('[data-lp-sticky-target]').forEach(function (stickyBar) {
      if (stickyBar.dataset.lpStickyBound) {
        return;
      }

      var targetId = stickyBar.getAttribute('data-lp-sticky-target');
      var heroForm = targetId ? document.getElementById(targetId) : null;
      if (!heroForm) {
        return;
      }

      stickyBar.dataset.lpStickyBound = 'true';

      function toggleSticky() {
        if (window.innerWidth > 900) {
          stickyBar.classList.remove('is-visible');
          return;
        }

        var allFormsVisible = Array.prototype.some.call(document.querySelectorAll('[data-lp-capture]'), function (form) {
          return elementInViewport(form);
        });

        if (window.scrollY > 400 && !allFormsVisible) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', toggleSticky, { passive: true });
      window.addEventListener('resize', toggleSticky);
      toggleSticky();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindStickyBars);
  } else {
    bindStickyBars();
  }
})();
